import { render, staticRenderFns } from "./ModalUpload.vue?vue&type=template&id=0b21ace4&scoped=true"
import script from "./ModalUpload.vue?vue&type=script&lang=js"
export * from "./ModalUpload.vue?vue&type=script&lang=js"
import style1 from "./ModalUpload.vue?vue&type=style&index=1&id=0b21ace4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b21ace4",
  null
  
)

export default component.exports